import React, { useState, useRef, useEffect,useCallback } from 'react';
import './site.css';
import axios from 'axios';
import RecordRTC from 'recordrtc';
import WaveSurfer from 'wavesurfer.js'
import RecordPlugin from 'wavesurfer.js/dist/plugins/record.esm.js'



export default function App() {


  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [muting, setMuting] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState('en-US'); 

  const [messageState, setMessageState] = useState({
    messages: []
  });

  const [isRecording, setIsRecording] = useState(false);
  const streamRef = useRef(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const recorderRef = useRef(null);
  const silenceTimeout = useRef(null);
  const audioContextRef = useRef(null);
  const processorRef = useRef(null);
  // const vad = useRef(null);
  const wavesurferRef = useRef(null);
  const recordRef = useRef(null);
  const [showCenter, setShowCenter] = useState(true);
  const [displayWave, setDisplayWave] = useState(true);
  const [displayLoading, setDisplayLoading] = useState(true);
  const progressRef = useRef(null);
  const [buttonClass, setButtonClass] = useState('check')
 


 
  const progressInterval = useRef(null);

  const startProgress = () => {
    let seconds = 0;
    progressInterval.current = setInterval(() => {
      seconds++;
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      progressRef.current.textContent = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    }, 1000);
  };

  const stopProgress = () => {
    setButtonClass('loader');
    clearInterval(progressInterval.current);
    progressInterval.current = null;
  };


  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;

      
      if (!wavesurferRef.current) {
        wavesurferRef.current = WaveSurfer.create({
          height: 60,
          container: '.wave',
          waveColor: 'rgb(108, 146, 87)',
          progressColor: 'rgb(100, 0, 100)',
        });
      }
  
      if (!recordRef.current) {
        recordRef.current = wavesurferRef.current.registerPlugin(RecordPlugin.create({ scrollingWaveform: true, renderRecordedAudio: false }));
      }


      recorderRef.current = new RecordRTC(stream, {
        type: 'audio',
        mimeType: 'audio/wav',
        disableLogs:true,
        recorderType: RecordRTC.StereoAudioRecorder,
      });
  
      recorderRef.current.startRecording();
      setIsRecording(true);
      recordRef.current.startRecording();
      document.getElementById('record').disabled = false;
  
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
      const source = audioContextRef.current.createMediaStreamSource(stream);
      processorRef.current = audioContextRef.current.createScriptProcessor(2048, 1, 1);
  
      source.connect(processorRef.current);
      processorRef.current.connect(audioContextRef.current.destination);
  
      processorRef.current.onaudioprocess = (event) => {
        const inputData = event.inputBuffer.getChannelData(0);
        let sum = 0.0;
        for (let i = 0; i < inputData.length; ++i) {
          sum += inputData[i] * inputData[i];
        }
        const rms = Math.sqrt(sum / inputData.length);
  
        if (rms < 0.01) {
          if (!silenceTimeout.current) {
            silenceTimeout.current = setTimeout(() => {
              stopRecording(); 
            }, 2000);
          }
        } else {
          clearTimeout(silenceTimeout.current);
          silenceTimeout.current = null;
        }
      };

      startProgress();


    } catch (error) {
      console.error('Error starting recording:', error);
    }
  };

  const stopRecording = () => {
    setButtonClass('loader');
    if (recorderRef.current) {
      recorderRef.current.stopRecording(async () => {
        const blob = recorderRef.current.getBlob();
        const audioUrl = URL.createObjectURL(blob);
        setAudioUrl(audioUrl);
        const isMeaningful = await analyzeAudioVolume(blob);
        if (isMeaningful) {
          await sendAudioToServer(blob);
        } else {
          if (!query) {
            alert('Could you please speak up? I did not hear you');
            setShowCenter(true);
            setDisplayWave(true);
            setButtonClass('check');
            return;
          }
          setQuery('');
        }
      });
      setIsRecording(false);
      if (recordRef.current) {
        recordRef.current.stopRecording();
      }
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }
    }

    stopProgress();

  };
  

  const handleRecordClick = () => {
    if (isRecording) {
      stopRecording();

    } else {
      setQuery('');
      startRecording();
      setShowCenter(!showCenter);
      setDisplayWave(false);
      
    }
  };


  const analyzeAudioVolume = async (audioBlob) => {
    const audioContext = new AudioContext();
    const arrayBuffer = await audioBlob.arrayBuffer();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    const rawData = audioBuffer.getChannelData(0); // Get the audio data
    let sum = 0;
    for (let i = 0; i < rawData.length; i++) {
      sum += Math.abs(rawData[i]);
    }
    const average = sum / rawData.length;
    const threshold = 0.01; // Adjust this threshold as needed
    return average > threshold;
  };

  
  const sendAudioToServer = async (audioBlob) => {
    if (!audioBlob) return;
    const formData = new FormData();
    formData.append('audio', audioBlob, 'recording.wav');
    try {
      const response = await axios.post('https://cicg2024test2-boi4jqzydq-uc.a.run.app/api/transcribe', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setQuery(response.data.transcription)
      setShowCenter(true);
      setDisplayWave(true);
      setButtonClass('check');
    } catch (error) {
      console.error('Error uploading audio file:', error);
    }
  };


  const [hoveredLink, setHoveredLink] = useState(null);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(null);
  const { messages } = messageState;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [threadID, setThreadID] = useState('');

  const closeSidebar = () => {
    const sidebar = document.querySelector('.sidebar');
    sidebar.style.right = '-100%';
    setSelectedFaqIndex(null);
  };

  const toggleAnswerVisibility = (index) => {
    setSelectedFaqIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const messageListRef = useRef(null);
  const textAreaRef = useRef(null);
  const [scrollbarNeeded, setScrollbarNeeded] = useState(false);

  const [muted] = useState(true);
  const video = useRef(null);

  // const toggleLanguage = () => {

  //   setSelectedLanguage((prevLanguage) => (prevLanguage === 'en-US' ? 'fr-FR' : 'en-US'));
  // };

  const placeholderText =
    selectedLanguage === 'en-US'
      ? loading
        ? 'Waiting for response...'
        : 'Type message...'
      : selectedLanguage === 'fr-FR'
      ? loading
        ? 'En attente de réponse...'
        : 'Tapez votre question ici...'
      : '';





  const handleMuteToggle = () => {
    setMuting(!muting);
  };


  const [audioData, setAudioData] = useState(null);
  const [audioPlayer, setAudioPlayer] = useState(null);

  useEffect(() => {
    if (audioData) {
      const audio = new Audio(audioData);
      audio.play();
    }
  }, [audioData]);

  useEffect(() => {
    if (audioPlayer) {
      audioPlayer.muted = muting;
    }
  }, [muting]);

  useEffect(() => {
    const messageList = messageListRef.current;
    if (messageList) {
      setScrollbarNeeded(messageList.scrollHeight > messageList.clientHeight);
    }
  }, [messages]);

  useEffect(() => {
    textAreaRef.current?.focus();
  }, []);

  useEffect(() => {
    if (messageListRef.current) {
      messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
    }
  }, [messages]);

  async function handleSubmit(e) {
    e.preventDefault();

    setError(null);

    if (!query) {
      alert('Please ask me a question');
      return;
    }

    const question = query.trim();

    let data_req = document.createElement('div');
    let container1 = document.createElement('div');
    let image_req = document.createElement('img');
    container1.setAttribute("class","usermessage");
    data_req.innerHTML = question;
    data_req.setAttribute("class","markdownanswer");
    data_req.style.background='rgba(215, 241, 220, .74)';
    data_req.style.color='#6c9257';

    image_req.setAttribute("class","usericon");
    image_req.src = './usericon.png';
    let message = document.getElementById('msg');
    message.appendChild(container1);
    container1.appendChild(image_req);
    container1.appendChild(data_req);
    
    
    let data_res = document.createElement('div');       
    let container2 = document.createElement('div');    
    let image_res = document.createElement('img');  
    container2.setAttribute("class","apimessage");
    image_res.setAttribute("class","boticon");
    image_res.src = './bot-image1.png';
    
    data_res.innerHTML = "...";
    data_res.setAttribute("class","markdownanswer");
    data_res.style.background='#ffff';

    message.appendChild(container2);      
    container2.appendChild(image_res);
    container2.appendChild(data_res);
    
    message.scrollTop = message.scrollHeight;

    setLoading(true);
    setQuery('');
    
    try {
      
     
      const eventSource = new EventSource(`https://cicg2024test2-boi4jqzydq-uc.a.run.app/api/request?userQuestion=${encodeURIComponent(question)}&threadId=${encodeURIComponent(threadID)}`);
      //const eventSource = new EventSource(`http://localhost:5000/api/request?userQuestion=${encodeURIComponent(question)}&threadId=${encodeURIComponent(threadID)}`);


      eventSource.onopen = (event) => {
        setLoading(false);
        data_res.innerHTML = '';
      };
      
      eventSource.onmessage = (event) => {
        var data = JSON.parse(event.data);
        
        if (data.end) {

          if(threadID === ''){
            setThreadID(data.threadId);
          }


          if (audioPlayer) {
            audioPlayer.pause();
            audioPlayer.currentTime = 0;
          }
  
          const newAudioData = new Audio(data.valueAudio);
     
          setAudioPlayer(newAudioData);
          newAudioData.muted = muting;
  
          newAudioData.addEventListener('play', () => {
            video.current?.play();
          });
  
          newAudioData.addEventListener('ended', () => {
            setAudioData(null);
            if (video.current) {
              video.current?.pause();
              video.current.currentTime = 0;
            }
          });
  
          newAudioData.play();


          data_res.innerHTML = data.valueText;
          message.scrollTop = message.scrollHeight;

          eventSource.close();
        } else {
          data_res.innerHTML = data.valueText;
        }
      };

      eventSource.onerror = (err) => {
        console.error('EventSource failed:', err);
        eventSource.close();
      };


    } catch (error) {
      setLoading(false);
      setError('An error occurred while fetching the data. Please try again.');
      console.log('error', error);
    }
  }

  const handleEnter = (e) => {
    if (e.key === 'Enter' && query) {
      handleSubmit(e);
    } else if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  useEffect(() => {
    // Start playing the video when the component mounts
    if (video.current) {
      video.current.load();
    }
  }, []);



  useEffect(() => {
    return () => {
      // Stop the audio player if there is one
      if (audioPlayer) {
        audioPlayer.pause();
        audioPlayer.currentTime = 0;
      }
    };
  }, []);
 

  return (

    <div className="layoutcontainer">
      <header className="header">
      
      </header>
      <main className="main">

        <div className="mx-auto flex flex-col gap-4">
          <main className="main">

            <div className="videomain">
              <div className="circle">
                <video
                  id="playVideo"
                  ref={video}
                  playsInline
                  width="100%"
                  height="100%"
                  title="Embedded Video"
                  loop
                  muted={muted}
                  preload="auto"
                >
                  <source src="./aiavatar.mp4" type="video/mp4" />
                </video>
                <button onClick={handleMuteToggle} className="muteaudio">
                  <img src={muting ? "./mute.png" : "./unmute.png"} />
                </button>
              </div>
            </div>

            <div className="chatmain">
              <div className="cloud">
                <div id = {'msg'}>
                
                </div>
              </div>

              <div className="center">
                <div className={showCenter ? 'cloudform' : 'cloudform-none'}>
                  

                  <textarea
                      disabled={loading}
                      onKeyDown={handleEnter}
                      ref={textAreaRef}
                      autoFocus={false}
                      rows={1}
                      maxLength={512}
                      id="userInput"
                      name="userInput"
                      placeholder={placeholderText}
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      className="textarea"
                    />

                    <button id="record" className="mic" onClick={handleRecordClick}>
                      <img
                        src={isRecording ? './btn-micRecord.png' : './btn-mic.png'}
                        alt={isRecording ? 'Recording' : 'Record'}
                      />
                    </button>
                 
                    <button
                     
                      disabled={loading}
                      className="generatebutton"
                      onClick={handleSubmit}
                    >
                      {loading ? (
                        <div className="loadingwheel">
                          <span className="loading">
                            <span style={{ backgroundColor:'#000' }} />
                            <span style={{ backgroundColor: '#000' }} />
                            <span style={{ backgroundColor: '#000' }} />
                          </span>
                        </div>
                      ) : (
                        <svg
                          viewBox="0 0 20 20"
                          className="svgicon"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ fill: '#6c9257' }} 
                        >
                          <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                        </svg>
                      )}
                    </button>
                </div>
                <div className={displayWave ? 'wave-none' : 'wave'} id="mic">

                <div className='progress' id="progress" ref={progressRef}>00:00</div>
                
                <button className={buttonClass} onClick={stopRecording}>
                    <img
                      src={'./check.png'}
                    />
                </button>


                </div>
              </div>
            </div>
          </main>
        </div>

      </main>


    </div>
);
}
